import {FileSearch02Icon} from '@components/ui/icon'
import {EmptyState} from '@components/commons/empty-search'
import {Trans, useTranslation} from '@/translations/i18n.tsx'
import {useParsedSearchParams} from '@hooks/useParsedSearchParams.ts'
import {AssignmentsURLParams} from '@features/home/types.ts'
import {Button} from '@components/ui/button'

export const HomeTableEmptySearch = ({onClearSearch}: {onClearSearch: () => void}) => {
    const {searchParams} = useParsedSearchParams(AssignmentsURLParams)

    const {t} = useTranslation()
    return (
        <EmptyState
            icon={<FileSearch02Icon size={32} />}
            title={t('home:table:empty_title', {tab: t(`home:${searchParams.filter_value}`)})}
            customContent={
                <div className="flex gap-1 items-center">
                    <Trans
                        i18nKey="home:table:empty_search:subtitle"
                        components={{
                            button: <Button onClick={onClearSearch} size={'sm'} variant={'tertiary'} shape={'text'} />
                        }}
                    />
                </div>
            }
        />
    )
}
